// ********* CardUserInputModalPrestador - userinputmodalprestador.jsx ********
// autor: W de Paula / MVinfo
// data: 09/11/24 | 00h59 | cópia quase que idêntica ao "userinputmodal.jsx"
// **************************************************




import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { getUserInfo , saveUserInfo} from '../../../../Services/getsaveuserinfo';
import Swal from 'sweetalert2';

const CardUserInputModalPrestador = ({ show, onHide, handleSave, servicoNome, servicoValor, servicoDataHora }) => {
    const [celular, setCelular] = useState('');
    const [nome, setNome] = useState('');
    const [obs, setObs] = useState('');

    const celularRef = useRef(null); // Criando um ref para o input de celular

    // Carregar dados do localStorage quando o componente monta
    useEffect(() => {
        const userInfo = getUserInfo();
        if (userInfo) {
            setNome(userInfo.nome);
            setCelular(userInfo.celular);
            setObs(userInfo.obs); // Certifique-se de recuperar também a observação
        }
    }, []);

    const handleSaveClick = () => {
        // console.log('nome: ', nome, 'celular: ', celular, 'obs: ', obs);
        if (nome === '' || celular ==='') {
            Swal.fire('Erro', 'Digite seu nome e celular para confirmar agendamento', 'error');
            return;
        }
        saveUserInfo(nome, celular);
        handleSave({ nome, celular, obs });
        onHide(); // Opcional: Fecha o modal após salvar
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title className='me-2'>Identifique-se</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label htmlFor="identifique">para que o(a) dono(a) do estabelecimento saiba quem é você e, 
                    possa entrar em contato, se necessário. Estes dados serão usados para seu 
                    cadastro básico de login no sistema Agendex.
                </label>
                <hr />
                <label htmlFor="celular">Celular com DDD:</label>
                <InputMask
                    mask={celular.length <= 10 ? "(99)9999-9999" : "(99)99999-9999"}
                    type="text"
                    id="celular"
                    className="form-control"
                    placeholder="Celular com DDD (whatsapp preferencial)"
                    value={celular}
                    onChange={(e) => setCelular(e.target.value)}
                    ref={celularRef} // Usando ref diretamente
                />
                <br />
                <label htmlFor="nome">Seu Nome:</label>
                <textarea
                    id="nome"
                    className="form-control"
                    placeholder="Seu Nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    minLength="3"
                />
                <br />
                <label htmlFor="obs">Observação:</label>
                <textarea
                    id="obs"
                    className="form-control"
                    placeholder="Se necessário, escreva aqui uma observação"
                    value={obs}
                    onChange={(e) => setObs(e.target.value)}
                />
                <br />
                <label htmlFor="obs">Serviço: {servicoNome}</label>
                <br />
                <label htmlFor="obs">Valor: {servicoValor}</label>
                <br />
                <label htmlFor="obs">Data / horário: {servicoDataHora} hs</label>
                <br />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSaveClick}>
                    Concluir Agendamento
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CardUserInputModalPrestador;